import logoImage from './../../images/crowcloud.png';

export default class LoginController {

	static get $inject(){
		return [
			'$state', 'AuthService','AlertsService', 'LanguageService'
		];
	}

	constructor($state, AuthService,AlertsService, LanguageService){

		this._$state = $state;
		this._AuthService = AuthService;
		this._AlertsService = AlertsService;
		this.languageService = LanguageService;
		
		this._AlertsService.add = this._AlertsService.add.bind(this._AlertsService);

		this.email = '';


	}

	// --- VM Helpers -----------------

	submit(){
		this._AuthService.forgotPassword(this.email)
			.then(()=>{
				this._$state.go('^.login');
			})
			.catch(this._AlertsService.add);
	}


	get logoImage(){
		return logoImage;
	}
	
	getTranslatableText(text){
		
		return this.languageService.getTranslatableText(text);
	}
}



/** WEBPACK FOOTER **
 ** ./src/guest/forgotPassword/controller.js
 **/